import { JsonInput } from 'src/components/uiElements/react-hook-fields/JsonInputReact'

export const WrapperConfig = ({ index, setList, item, id }) => {
  const onConfigChange = (e) => {
    console.log('onConfigChange e', e)
    const newVal = e
    const setAndRestoreItem = (item) => {
      return {
        ...item,
        config: newVal,
      }
    }
    setList((prev) => prev.map((item) => (item.id === id ? setAndRestoreItem(item) : item)))
  }

  return (
    <>
      <JsonInput source={`config`} onChange={onConfigChange} />
    </>
  )
}
